import { button } from 'ui/styles/Commons/button';
import { media } from 'ui/styles/theme';

export const errorModal = {
  backstage: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(225, 225, 225, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    boxShadow: '0 11px 32px 2px rgba(0,0,0,0.1)',
    fontFamily: 'Roboto',
    [media.mobile]: {
      width: '90%',
      maxWidth: '400px',
      maxHeight: '90vh',
      overflowY: 'scroll',
    },
    [media.desktop]: {
      width: '630px',
    },
  },
  title: {
    fontSize: '1.4rem',
    textAlign: 'center',
    fontWeight: 500,
    [media.mobile]: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
      margin: '2rem 0',
    },
    [media.desktop]: {
      fontSize: '1.75rem',
      lineHeight: '1.75rem',
      margin: '3rem 0 2rem 0',
    },
  },
  errorMessage: {
    textAlign: 'center',
    marginTop: '3rem',
    [media.mobile]: {
      maxWidth: '90%',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
    },
    [media.desktop]: {
      maxWidth: '80%',
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '2rem',
    },
  },
  ok: {
    ...button.yellow,
    margin: '2rem 0',
  },
};

